<template>
  <v-container align-content-center>
    <v-layout column>
      <v-flex xs12 sm12 md12>
        <v-card>
          <v-card-title class="headline">{{ $t('key360')}}</v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 sm6 pa-1>
                <v-dialog
                  ref="dialog"
                  v-model="dadatadlg"
                  :return-value.sync="dadata"
                  persistent
                  lazy
                  full-width
                  width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="dadata"
                      :label="$t('key136')"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    locale="it-IT"
                    v-model="dadata"
                    scrollable
                    :min="minPartenza"
                    :max="maxPartenza"
                    @input="$refs.dialog.save(dadata)"
                  >
                    <v-spacer></v-spacer>
                    <v-btn flat color="#4EABDD" @click="dadatadlg = false"
                      >Annulla</v-btn
                    >
                    <v-btn flat color="#4EABDD" @click="checkFinale">OK</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-flex>
              <v-flex xs12 sm6 pa-1>
                <v-dialog
                  ref="dialog2"
                  v-model="adatadlg"
                  :return-value.sync="adata"
                  persistent
                  lazy
                  full-width
                  width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="adata"
                      :label="$t('key137')"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    locale="it-IT"
                    v-model="adata"
                    scrollable
                    :min="minArrivo"
                    :max="maxArrivo"
                    @input="$refs.dialog2.save(adata)"
                  >
                    <v-spacer></v-spacer>
                    <v-btn flat color="#4EABDD" @click="adatadlg = false"
                      >Annulla</v-btn
                    >
                    <v-btn
                      flat
                      color="#4EABDD"
                      @click="$refs.dialog2.save(adata)"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-dialog>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm12 md6 pa-1>
                <v-text-field
                  v-model="mittente"
                  :label="$t('key340')"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md6 pa-1>
                <v-text-field
                  v-model="destinatario"
                  :label="$t('key120')"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm12 md6 pa-1>
                <v-layout row wrap>
                  <v-flex xs2>
                    <v-text-field
                      v-model="annonumrit"
                      :label="$t('key044')"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs2>
                    <v-text-field
                      v-model="filialenumrit"
                      :label="$t('key045')"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs8>
                    <v-text-field
                      v-model="numeronumrit"
                      :label="$t('key361')"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 sm12 md6 pa-1>
                <v-text-field
                  v-model="numritweb"
                  :label="$t('key362')"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm12 md6 pa-1>
                <v-btn large style="box-shadow: none; color: white;" color="#4EABDD" block @click="cerca">{{ $t('key004') }}</v-btn>
              </v-flex>
              <v-flex xs12 sm12 md6 pa-1>
                <div style="margin-top: 20px">
                  {{ $t('key363') }} {{ numritiritrovati }}
                </div>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-text>
            <v-data-table
              v-bind:headers="headers"
              v-bind:items="this.items"
              v-bind:search="search"
              disable-initial-sort
              :pagination.sync="pagination"
              :loading="loading"
            >
              <template slot="items" slot-scope="props">
                <tr @click="dettaglioRitiro(props.item.r2nrit)">
                  <td class="text-xs-left">{{ props.item.r2dtrr }}</td>
                  <td class="text-xs-left" style="background-color: #f4f4f4">
                    {{ props.item.r2nritview }}
                  </td>
                  <td class="text-xs-left">{{ props.item.r2rweb }}</td>
                  <td class="text-xs-left">{{ props.item.r2stat }}</td>
                  <td class="text-xs-left">{{ props.item.r2trit }}</td>
                  <td class="text-xs-left">{{ props.item.r2unva }}</td>
                  <td class="text-xs-left">{{ props.item.r2rags }}</td>
                  <td class="text-xs-left">{{ props.item.r3rags }}</td>
                </tr>
              </template>
              <template slot="pageText" slot-scope="{ pageStart, pageStop }"
                >From {{ pageStart }} to {{ pageStop }}</template
              >
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  data: () => ({
    dadatadlg: false,
    adatadlg: false,
    items: [],
    headers_it: [
      { text: "Data ritiro", align: "left", value: "r2dtrr" },
      { text: "Num. ritiro", align: "left", value: "r2nritview" },
      { text: "Num. ritiro web", align: "left", value: "r2rweb" },
      { text: "Stato", align: "left", value: "r2stat" },
      { text: "Tipo ritiro", align: "left", value: "r2trit" },
      { text: "Tipo destinazione", align: "left", value: "r2unva" },
      { text: "Mittente", align: "left", value: "r2rags" },
      { text: "Destinatario", align: "left", value: "r3rags" },
    ],
    headers_en: [
      { text: "Pick up order date", align: "left", value: "r2dtrr" },
      { text: "Pick up order number", align: "left", value: "r2nritview" },
      { text: "Pick up order web number", align: "left", value: "r2rweb" },
      { text: "Status", align: "left", value: "r2stat" },
      { text: "Pick up order type", align: "left", value: "r2trit" },
      { text: "Destination type", align: "left", value: "r2unva" },
      { text: "Sender", align: "left", value: "r2rags" },
      { text: "Receiver", align: "left", value: "r3rags" },
    ],
    headers: [],
    annonumrit: "",
    filialenumrit: "",
    numeronumrit: "",
    search: "",
    pagination: { sortBy: "r2dtrr", descending: true, rowsPerPage: 25 },
    numrit: "",
    numritweb: "",
    dadata: "",
    adata: "",
    minArrivo: "",
    maxArrivo: "",
    minPartenza: "",
    maxPartenza: "",
    mittente: "",
    destinatario: "",
    numritiritrovati: 0,
    loading: false,
  }),
  created(){
    this.$store.dispatch("ImpostaScollegamento");
  },
  mounted() {
    if(this.$i18n.locale=='it') {
      this.headers = this.headers_it;
    } else {
      this.headers = this.headers_en;
    }
    this.minPartenza = this.addDays(new Date(), -365)
      .toISOString()
      .substr(0, 10);
    this.maxPartenza = new Date().toISOString().substr(0, 10);
    this.minArrivo = this.addDays(new Date(), -365).toISOString().substr(0, 10);
    this.maxArrivo = new Date().toISOString().substr(0, 10);
    this.annonumrit = new Date().toISOString().substr(0, 4);
  },
  methods: {
    convalida() {
      var ok = true;
      // if ((this.dadata === "" || this.adata === "") && this.numrit === "") {
      //   ok = false;
      // }
      return ok;
    },
    cerca() {
      // Convalida il contenuto dei campi
      if (this.convalida()) {
        // Crea il numero di ritiro completo
        if (this.filialenumrit !== "" && this.numeronumrit !== "") {
          this.numrit =
            this.annonumrit +
            this.filialenumrit.padStart(3, "0") +
            this.numeronumrit.padStart(6, "0");
        } else {
          this.numrit = "";
        }
        // Se convalidato procede con l'estrazione dei dati
        this.loading = true;
        axios
          .post(this.$store.state.servicePath + "/api/Riti210f/GetTracking", {
            dadata: this.dadata,
            adata: this.adata,
            numrit: this.numrit,
            mittente: this.mittente,
            destinatario: this.destinatario,
            numritweb: this.numritweb,
          })
          .then((res) => {
            this.items = res.data;
            this.numritiritrovati = this.items.length;
            this.items.forEach((el) => {
              // Tipo destinatario
              if (el.r2unva === "U") {
                if(this.$i18n.locale=='it') {
                    el.r2unva = "UNICA";
                } else {
                    el.r2unva = "SINGLE";
                }
              }
              if (el.r2unva === "V") {
                if(this.$i18n.locale=='it') {
                    el.r2unva = "VARIE";
                } else {
                    el.r2unva = "MULTIPLE";
                }

              }
              // Tipo porto
              if (el.r2trit === "F") {
                if(this.$i18n.locale=='it') {
                    el.r2trit = "FRANCO";
                } else {
                    el.r2trit = "DAP";
                }
              }
              if (el.r2trit === "A") {
                if(this.$i18n.locale=='it') {
                    el.r2trit = "ASSEGNATO";
                } else {
                    el.r2trit = "EXWORK";
                }
              }
              if (el.r2trit === "T") {
                if(this.$i18n.locale=='it') {
                    el.r2trit = "TRIANGOLAZIONE";
                } else {
                    el.r2trit = "CROSS TRADE ORDER";
                }
              }
              // Se ritiro web 0 cancella la stringa
              if (el.r2rweb === 0) {
                el.r2rweb = "";
              }
              // Stati del ritiro
              if (el.r2stat === "RIT") {
                if(this.$i18n.locale=='it') {
                    el.r2stat = "RITIRATO";
                } else {
                    el.r2stat = "GOODS COLLECTED";
                }
              }
              if (el.r2stat === "INS") {
                if(this.$i18n.locale=='it') {
                    el.r2stat = "INSERITO";
                } else {
                    el.r2stat = "PICK UP ORDER WELL RECEIVED";
                }
              }
              if (el.r2stat === "AFF") {
                if(this.$i18n.locale=='it') {
                    el.r2stat = "AFFIDATO";
                } else {
                    el.restat = "IN COLLECTION";
                }
              }
              if (el.r2stat === "NOR") {
                if(this.$i18n.locale=='it') {
                    el.r2stat = "NON RITIRATO";
                } else {
                    el.r2stat = "GOODS NOT COLLECTED";
                }
              }
              if (el.r2stat === "ANA") {
                if(this.$i18n.locale=='it') {
                    el.r2stat = "ANNULLO AFFIDATO";
                } else {
                    el.r2stat = "CANCELLED";
                }
              }
              // Formatta la data
              el.r2dtrr =
                el.r2dtrr.toString().substring(6, 8) +
                "/" +
                el.r2dtrr.toString().substring(4, 6) +
                "/" +
                el.r2dtrr.toString().substring(0, 4);
              // Formatta il numero del ritiro
              el.r2nritview =
                el.r2nrit.toString().substring(0, 4) +  
                "-" +
                el.r2nrit.toString().substring(4, 7) +
                "-" +
                el.r2nrit.toString().substring(7);
            });
            this.loading = false
          });
      }
    },
    dettaglioRitiro(id) {
      // Carica il dettaglio del ritiro
      this.$router.push({ path: `/trackingritiridetail/${id}` });
    },
    checkFinale() {
      this.$refs.dialog2.save(this.dadata);
      this.minArrivo = this.dadata;
      this.maxArrivo = new Date().toISOString().substr(0, 10);
    },
    addDays(date, days) {
      date.setDate(date.getDate() + days);
      return date;
    },
  },
};
</script>